export default Object.freeze({
  ME: "Me",
  OTHER: "Other",
});
